<template>
  <div class="language-selector-wrapper" style="position: fixed; top: 0; right: 100px; text-align: right; margin-right: 10px;">
    <div class="btn-group">
      <button
          :class="{btn: true, 'btn-secondary': this.$parent.$i18n.locale == 'ja', 'btn-default': this.$parent.$i18n.locale != 'ja'}"
          style="color: white; font-weight: bold; text-shadow: #0a0a0a 1px 1px 1px;"
          @click.prevent="changeLang('ja')">
        日本語
      </button>
      <button
          :class="{btn: true, 'btn-secondary': this.$parent.$i18n.locale == 'en', 'btn-default': this.$parent.$i18n.locale != 'en'}"
          class="btn btn-default"
          style="color: white; font-weight: bold; text-shadow: #0a0a0a 1px 1px 1px;"
          @click.prevent="changeLang('en')">
        English
      </button>
      <button
          :class="{btn: true, 'btn-secondary': this.$parent.$i18n.locale == 'cn', 'btn-default': this.$parent.$i18n.locale != 'cn'}"
          class="btn btn-default"
          style="color: white; font-weight: bold; text-shadow: #0a0a0a 1px 1px 1px;"
          @click.prevent="changeLang('cn')">
        中文
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LangSelector',
  data () {
    return {}
  },
  methods: {
    changeLang: function (lang) {
      this.$root.$i18n.locale = lang
      this.$root.$store.commit('update', { field: 'lang', value: lang })
    }
  }
}
</script>
